import { useEffect } from "react";
import Rollbar from "rollbar";
import config from "config/config";

const useRollbar = () => {
  useEffect(() => {
    const rollbar = new Rollbar();

    rollbar.configure({
      accessToken: config.rollbarAccessToken,
      captureUncaught: true,
      captureUnhandledRejections: true,
      scrubTelemetryInputs: true,
      payload: {
        environment: config.buildEnv,
        client: {
          javascript: {
            source_map_enabled: true,
            code_version: config.buildVersion,
            guess_uncaught_frames: true,
          },
        },
      },
    });
  }, []);
};

export default useRollbar;
